export default {
  description: {
    padding: '0 8em 1em',
  },
}
